import React, { useState, useEffect } from "react"
import { Row, Col, Stack, Card } from "react-bootstrap"
import { Row as AntRow, Col as AntCol } from "antd"
import NoDataImg from "../../Assets/Images/Dashboard/no-data.png"
import { Bar, Doughnut, Line } from "react-chartjs-2"
import Navbar from "../../Components/Navbar/Navbar"
import Footer from "../../Components/Footer/Footer"
import { useNavigate } from "react-router-dom"
import "../../Components/Navbar/Navbar.css"
import "./Dashboard4.css"
import {
  formatDateNoTime,
  getName,
  numberFormat,
  getTodayDate,
} from "../../Helpers/Utils/Common"
import {
  getDashboardLogs,
  getDashboardSummary,
} from "../../Helpers/apiCalls/DashboardApi"
import { SyncLoader } from "react-spinners"
import Clock from "react-clock"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
} from "chart.js"

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement
)

export default function Dashboard4() {
  const navigate = useNavigate()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(true)
  const [dashboardData, setDashboardData] = useState([])
  const [dashboardSummaryData, setDashboardSummaryData] = useState([])
  const [currentTime, setCurrentTime] = useState(new Date())

  const days = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  }

  const months = [
    { name: "Jan", value: "January" },
    { name: "Feb", value: "February" },
    { name: "Mar", value: "March" },
    { name: "Apr", value: "April" },
    { name: "May", value: "May" },
    { name: "Jun", value: "June" },
    { name: "Jul", value: "July" },
    { name: "Aug", value: "August" },
    { name: "Sept", value: "September" },
    { name: "Oct", value: "October" },
    { name: "Nov", value: "November" },
    { name: "Dec", value: "December" },
  ]

  const handleLineGraphMonthClick = (event, elements) => {
    if (elements.length > 0) {
      const clickedElementIndex = elements[0].index
      const clickedMonth = months[clickedElementIndex].value

      // Navigate to the expense by type page with the month as a parameter
      setTimeout(() => navigate(`/expensebytype?month=${clickedMonth}`), 0)
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getDashboardLogs(getTodayDate())
        const summaryData = await getDashboardSummary(getTodayDate())
        console.log(response)
        console.log(summaryData)
        if (response.data) {
          setDashboardData(response.data)
        } else if (response.error) {
        }
        if (summaryData.data) {
          setDashboardSummaryData(summaryData.data)
        } else if (summaryData.error) {
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
      setShowLoader(false)
    }
    fetchData()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  const renderContent = () => {
    // check if dashboardSummaryData and its properties are defined before accessing them
    const currentSales = dashboardSummaryData.current_sales
      ? dashboardSummaryData.current_sales.replace(/,/g, "")
      : "0"
    const currentExpense = dashboardSummaryData.current_expense
      ? dashboardSummaryData.current_expense.replace(/,/g, "")
      : "0"
    const netSales = dashboardSummaryData.net_sales
      ? dashboardSummaryData.net_sales.replace(/,/g, "")
      : "0"

    const doughnutDataSales = {
      // Most sales donut chart
      labels:
        dashboardSummaryData.most_sales?.map((item) => item.item_name) || [],
      datasets: [
        {
          data:
            dashboardSummaryData.most_sales?.map((item) =>
              Number(item.total_qty)
            ) || [],
          backgroundColor: ["#0E3746", "#588194", "#3D7CB8", "#79B3E7"],
          borderWidth: 0,
        },
      ],
    }
    const hasSalesData = doughnutDataSales.datasets[0].data.length > 0

    const doughnutDataExpenses = {
      // Expenses donut chart
      labels: dashboardSummaryData.expenses?.map((item) => item.type) || [],
      datasets: [
        {
          data:
            dashboardSummaryData.expenses?.map((item) => {
              const grandTotal = item.grand_total
              return grandTotal ? Number(grandTotal.replace(/,/g, "")) : 0
            }) || [],
          backgroundColor: ["#DC3545", "#B92C34", "#F4626C", "#F04C57"],
          borderWidth: 0,
        },
      ],
    }
    const hasExpensesData = doughnutDataExpenses.datasets[0].data.length > 0

    const barData = {
      //Income & expense bar chart
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Income",
          data:
            dashboardSummaryData.income_and_expense?.income?.map(
              (item) => item.monthly_sales
            ) || [],
          backgroundColor: "#0E3746",
        },
        {
          label: "Expense",
          data:
            dashboardSummaryData.income_and_expense?.expenses?.map(
              (item) => item.monthly_expense
            ) || [],
          backgroundColor: "#DC3545",
        },
      ],
    }

    const uniqueExpenseTypes = [
      ...new Set(
        dashboardSummaryData.monthly_expense_report?.map((item) => item.type) ||
          []
      ),
    ] // Expense line chart
    const lineData = {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: uniqueExpenseTypes.map((type, index) => ({
        label: type,
        data: Array(12)
          .fill(null)
          .map((_, monthIndex) => {
            const expense = dashboardSummaryData.monthly_expense_report?.find(
              (item) =>
                item.type === type && parseInt(item.month) === monthIndex + 1
            )
            return expense &&
              expense.monthly_expense !== "0" &&
              expense.monthly_expense !== "0.00"
              ? parseFloat(expense.monthly_expense)
              : null // return null if no expense or expense is "0" or "0.00"
          }),
        borderColor: `hsl(${
          index * (360 / uniqueExpenseTypes.length)
        }, 70%, 50%)`,
        pointBackgroundColor: `hsl(${
          index * (360 / uniqueExpenseTypes.length)
        }, 70%, 50%)`,
        fill: false,
        tension: 0.1,
        spanGaps: true,
      })),
    }

    const handleLineGraphMonthClick = (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index
        const clickedMonth = months[clickedElementIndex].value
        setTimeout(() => navigate(`/expensebytype?month=${clickedMonth}`), 0)
      }
    }

    return (
      <div className="dashboard-content">
        <Row className="d-flex justify-content-between align-items-end ms-md-0 ps-md-0 fs-2 pt-1">
          <Col xs={"auto"}>
            <h2 className="greeting">
              Hello, <b>{getName()}!</b>👋
            </h2>
          </Col>
          <Col xs={"auto"}>
            <h3 className="date-and-time">
              {`${currentTime.toLocaleTimeString()} ${
                days[currentTime.getDay()]
              } | ${formatDateNoTime(currentTime)}`}
            </h3>
          </Col>
        </Row>
        <AntRow className="mt-3" gutter={[10, 10]}>
          <AntCol xs={24} sm={8}>
            <Card className="mb-1">
              <Card.Body>
                <Card.Title className="sm-card-title">Current Sales</Card.Title>
                <Card.Text
                  onClick={() => navigate("/wholesaleinvoice")}
                  style={{ cursor: "pointer" }}
                >
                  {isNaN(Number(currentSales))
                    ? "0.00"
                    : numberFormat(Number(currentSales))}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={8}>
            <Card className="mb-1">
              <Card.Body>
                <Card.Title className="sm-card-title">
                  Current Expenses
                </Card.Title>
                <Card.Text
                  onClick={() => navigate("/purchaseinvoice")}
                  style={{ cursor: "pointer" }}
                >
                  {isNaN(Number(currentExpense))
                    ? "0.00"
                    : numberFormat(Number(currentExpense))}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={8}>
            <Card className="mb-1">
              <Card.Body>
                <Card.Title className="sm-card-title">Net Income</Card.Title>
                <Card.Text>
                  {isNaN(Number(netSales))
                    ? "0.00"
                    : numberFormat(Number(netSales))}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
        </AntRow>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={7}>
            <Card className="mb-1 h-100">
              <Card.Body>
                <Card.Title>Income and Expense Report</Card.Title>
                <div className="chart-container">
                  {/* <Bar data={barData} options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    onClick: (mouseEvent, array) => {
                      if (array[0]) {
                        const chartElement = array[0];
                        const label = barData.datasets[chartElement.datasetIndex].label;
                        switch (label) {
                          case 'Income':
                            setTimeout(() => navigate('/wholesaleinvoice'), 0);
                            break;
                          case 'Expense':
                            setTimeout(() => navigate('/expenses'), 0);
                            break;
                          default:
                            break;
                        }
                      }
                    }
                  }} /> */}
                  <Bar
                    data={barData}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      onClick: (mouseEvent, array) => {
                        if (array[0]) {
                          const chartElement = array[0]
                          const datasetIndex = chartElement.datasetIndex
                          const dataIndex = chartElement.index
                          const label = barData.datasets[datasetIndex].label
                          const monthName = barData.labels[dataIndex]
                          const fullMonth = months.find(
                            (month) => month.name === monthName
                          ).value

                          switch (label) {
                            case "Income":
                              setTimeout(
                                () =>
                                  navigate(
                                    `/wholesaleinvoice/?month=${fullMonth}`
                                  ),
                                0
                              )
                              break
                            case "Expense":
                              setTimeout(
                                () => navigate(`/expenses?month=${fullMonth}`),
                                0
                              )
                              break
                            default:
                              break
                          }
                        }
                      },
                    }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="most-sales-card" xs={12} sm={12} md={5}>
            <Card className="mb-1 h-100 donut-card">
              <Card.Body>
                <Card.Title>Most Sales</Card.Title>
                <div
                  className="doughnut-container"
                  onClick={() => navigate("/wholesale-top-selling-item")}
                >
                  {hasSalesData ? (
                    <>
                      <div className="doughnut-chart">
                        <Doughnut
                          data={doughnutDataSales}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: { legend: { display: false } },
                          }}
                        />
                      </div>
                      <div className="legend-list">
                        {doughnutDataSales.labels.map((label, index) => (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  doughnutDataSales.datasets[0].backgroundColor[
                                    index %
                                      doughnutDataSales.datasets[0]
                                        .backgroundColor.length
                                  ],
                              }}
                            ></span>
                            <span className="legend-label">{label}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="no-data-donut">
                      <img
                        src={NoDataImg}
                        alt="No data"
                        className="no-data-image"
                      />
                      <span className="no-data-message">No data found.</span>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3 ">
          <Col className="expenses-card" xs={12} sm={12} md={5}>
            <Card className="mb-1 h-100">
              <Card.Body>
                <Card.Title>Expenses</Card.Title>
                <div className="doughnut-container">
                  {hasExpensesData ? (
                    <>
                      <div className="doughnut-chart">
                        <Doughnut
                          data={doughnutDataExpenses}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: { legend: { display: false } },
                          }}
                        />
                      </div>
                      <div className="legend-list">
                        {doughnutDataExpenses.labels.map((label, index) => (
                          <div key={index} className="legend-item">
                            <span
                              className="legend-color"
                              style={{
                                backgroundColor:
                                  doughnutDataExpenses.datasets[0]
                                    .backgroundColor[
                                    index %
                                      doughnutDataExpenses.datasets[0]
                                        .backgroundColor.length
                                  ],
                              }}
                            ></span>
                            <span className="legend-label">{label}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="no-data-donut">
                      <img
                        src={NoDataImg}
                        alt="No data"
                        className="no-data-image"
                      />
                      <span className="no-data-message">No data found.</span>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={7}>
            <Card className="mb-1 h-100">
              <Card.Body>
                <Card.Title>Monthly Expense Report</Card.Title>
                <div className="chart-container">
                  <Line
                    data={lineData}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      boxBackgroundColor: "rgba(255, 255, 255, 0.8)",
                      // onClick: (mouseEvent, array) => {
                      //   if (array[0]) {
                      //     mouseEvent.native.stopImmediatePropagation();
                      //     setTimeout(() => navigate('/expensebytype'), 0);
                      //   }
                      // }
                      onClick: handleLineGraphMonthClick,
                    }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <AntRow className="mt-3" gutter={[10, 10]}>
          <AntCol xs={24} sm={6}>
            <Card>
              <Card.Body
                onClick={() => navigate("/purchaseorders")}
                style={{ cursor: "pointer" }}
              >
                <Card.Title className="sm-card-title">Pending PO</Card.Title>
                <Card.Text>
                  {dashboardSummaryData.po_for_approval_count}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={6}>
            <Card>
              <Card.Body
                onClick={() => navigate("/purchaseorders")}
                style={{ cursor: "pointer" }}
              >
                <Card.Title className="sm-card-title">Incomplete PO</Card.Title>
                <Card.Text>
                  {dashboardSummaryData.po_incomplete_count}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={6}>
            <Card>
              <Card.Body
                onClick={() => navigate("/suppliesexpenses")}
                style={{ cursor: "pointer" }}
              >
                <Card.Title className="sm-card-title">
                  Pending Expense PO
                </Card.Title>
                <Card.Text>
                  {dashboardSummaryData.supplies_for_approval_count}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={6}>
            <Card>
              <Card.Body
                onClick={() => navigate("/pettycash")}
                style={{ cursor: "pointer" }}
              >
                <Card.Title className="sm-card-title">
                  Petty Cash Request
                </Card.Title>
                <Card.Text>
                  {dashboardSummaryData.petty_cash_request_count}
                </Card.Text>
              </Card.Body>
            </Card>
          </AntCol>
        </AntRow>
        <AntRow className="mt-3" gutter={[10, 10]}>
          <AntCol xs={24} sm={8}>
            <Card>
              <Card.Body>
                <Card.Title className="sm-card-title">Adjustments</Card.Title>
                <div className="inventory-adj">
                  {dashboardData.adjustments_pending_office?.length === 0 ? (
                    <div className="no-data-found d-flex justify-content-center">
                      <span>
                        <img
                          src={NoDataImg}
                          alt="no data found"
                          width={20}
                          height={20}
                        />
                      </span>
                      <p className="no-data-label mx-1">No data found.</p>
                    </div>
                  ) : (
                    <>
                      {dashboardData.adjustments_pending_office?.map(
                        (data, i) => {
                          return (
                            <Stack>
                              <hr />
                              <Row>
                                <Col>
                                  <button
                                    className="inventory-btn"
                                    onClick={() => navigate("/adjustments")}
                                  >
                                    <div className="inventory-btn-label">
                                      {data?.branch_name +
                                        " - " +
                                        data?.total_count}
                                    </div>
                                  </button>
                                </Col>
                              </Row>
                            </Stack>
                          )
                        }
                      )}
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={8}>
            <Card>
              <Card.Body>
                <Card.Title className="sm-card-title">Low on Stocks</Card.Title>
                <div className="inventory-adj">
                  {dashboardData.low_stock_items?.length === 0 ? (
                    <div className="no-data-found d-flex justify-content-center">
                      <span>
                        <img
                          src={NoDataImg}
                          alt="no data found"
                          width={20}
                          height={20}
                        />
                      </span>
                      <p className="no-data-label mx-1">No data found.</p>
                    </div>
                  ) : (
                    <>
                      {dashboardData.low_stock_items?.map((data, i) => {
                        return (
                          <Stack>
                            <hr />
                            <Row>
                              <Col>
                                <button
                                  className="inventory-btn"
                                  onClick={() =>
                                    navigate("/lowonstock", {
                                      state: { signed_qty: "" },
                                    })
                                  }
                                >
                                  <div className="inventory-btn-label">
                                    {data?.branch +
                                      " - " +
                                      data?.low_stock_items}
                                  </div>
                                </button>
                              </Col>
                            </Row>
                          </Stack>
                        )
                      })}
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </AntCol>
          <AntCol xs={24} sm={8}>
            <Card>
              <Card.Body>
                <Card.Title className="sm-card-title">
                  Negative Inventories
                </Card.Title>
                <div className="inventory-adj">
                  {dashboardData.negative_inventory?.length === 0 ? (
                    <div className="no-data-found d-flex justify-content-center">
                      <span>
                        <img
                          src={NoDataImg}
                          alt="no data found"
                          width={20}
                          height={20}
                        />
                      </span>
                      <p className="no-data-label mx-1">No data found.</p>
                    </div>
                  ) : (
                    <>
                      {dashboardData.negative_inventory?.map((data, i) => {
                        return (
                          <Stack>
                            <hr />
                            <Row>
                              <Col>
                                <button
                                  className="inventory-btn"
                                  onClick={() =>
                                    navigate("/lowonstock", {
                                      state: { signed_qty: "negative" },
                                    })
                                  }
                                >
                                  <div className="inventory-btn-label">
                                    {data?.branch + " - " + data.negative_items}
                                  </div>
                                </button>
                              </Col>
                            </Row>
                          </Stack>
                        )
                      })}
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </AntCol>
        </AntRow>
      </div>
    )
  }

  return showLoader ? (
    <div className="dashboard-wrapper">
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"DASHBOARD"}
        />
        <div className={`dashboard ${inactive ? "inactive" : "active"}`}>
          <Row className="d-flex justify-content-between align-items-end">
            <Col xs={"auto"}>
              <h2 className="greeting">
                Hello, <b>{getName()}!</b>👋
              </h2>
            </Col>
            <Col xs={"auto"}>
              <Clock value={currentTime} />
            </Col>
          </Row>
          <div className="d-flex justify-content-center my-5 mt-5 pt-5">
            <SyncLoader color="var(--primary-color)" size={15} />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="dashboard-wrapper">
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"DASHBOARD"}
        />
        <div className={`dashboard ${inactive ? "inactive" : "active"}`}>
          {renderContent()}
        </div>
        <Footer />
      </div>
    </div>
  )
}
